
<template>
    <div class="index-outer">
    <myheader></myheader>
    <div class="type PcStyle1">
    <el-form
        class="login-form"
      >
        <h1 class="biaoti">欢迎登录</h1>
        <h4 class="Stitle">上海交通大学钱学森图书馆团队参观申请服务管理系统</h4>
        <div class="waikuang">
        <div class="yuyue"><h2 class="ziti">预约方式</h2>
        </div>
        <el-form-item label="" class="redbox">
          <div @click="gotype(0)" class="typezi">
              常规团队（20-50人）
        </div >
        </el-form-item>
        <el-form-item label=""  class="redbox1" >
          <div @click="gotype(1)" class="typezi">
            中小学生团队（20-99人）
        </div >
        </el-form-item>
        
        <el-form-item label=""  class="redbox1" >
          <div @click="gotype(2)" class="typezi">
            中小学生团队（大于100人）
        </div >
        </el-form-item>
        <el-form-item label=""  class="redbox1" >
          <div @click="gotype(3)" class="typezi">
            社教活动（20-50人）
        </div >
        </el-form-item>
      </div>
        </el-form>
</div>
<el-dialog
      :visible.sync="show"
      width="50%"
      :show-close="false"
      :close-on-click-modal="false"
      class="el-dialog-code"
    >
      <div class="pull">
        <div class="pull-title">参观须知</div>
        <div class="pull-text">
          <p style="margin-bottom: 20px;">简介：微党课《人民的满意就是最高的奖赏--共产党员钱学森》聚焦共产党员钱学森毕生践行的“人民至上”理念，以充满故事性的讲述方式，解读钱学森一生之中为国为民所做出的五次重大人生选择。通过钱学森的杰出贡献、感人事迹和崇高品格，号召广大党员从中获取历史启示、体悟爱国主义、汲取精神力量。微党课时长12分钟。
           温馨提示：请先预约当日讲解场次，待获得讲解时间段后，再预约微党课。感谢配合！</p>
          <p>1、有讲解需求的观众团队须提前7-14个自然日登陆钱学森图书馆参观申请服务与管理系统，在线提交团队信息与参观需求进行报名登记。</p>
          <p>2、讲解团队人数要求为{{ num }}</p>
      
        </div>
        <div class="pull-sumbit" @click="SubmitEvent">确定</div>
      </div>
    </el-dialog>
    </div>

    
</template>

<script>
import myheader from "../components/myheader.vue";

export default {
 data() {
  return{
    type:0,
    show: false,
    num:"",
  }
 },
    components: {
    myheader,
  
},

methods:{
  gotype(type){
    this.type = type;
    this.show =true;
    switch(type){
      case 0:
      this.num ="20-50人，超过50人团队需申请2个批次。";
      break;
      case 1:
      this.num ="20-99人，超过100人团队需申请2个批次。";
      break;
      case 2:
      this.num ="大于100人。";
      break;
      case 3:
      this.num ="20-50人，超过50人团队需申请2个批次。";
      break;
    }
    
  
  },
SubmitEvent(){
  this.show = false
  this.$router.push("/Pindex?type="+this.type);
}
}

}
</script>

<style scoped lang="less">

.biaoti{
/* 欢迎登录 */
color: rgb(170, 32, 32);
font-size: 40px;
font-weight: 700px;
line-height: 59px;
letter-spacing: 2px;
text-align: left

}
.ziti{
color: rgb(0, 0, 0);
font-size: 22px;
font-weight: 400px;
line-height: 59px;
letter-spacing: 2px;
text-align: center;

}
.typezi{
  /* 常规团队（20-50人） */
color: rgb(255, 255, 255);
font-size: 20px;
font-weight: 400px;
line-height: 59px;
letter-spacing: 2px;
text-align: center  !important;
}
.type {
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover;
}
.waikuang{
 /* 矩形 145 */
position: absolute;
width: 552px;
height: 456px;
box-sizing: border-box;


border: 1px solid rgb(162, 161, 161);

border-radius:
11px;


}
.el-dialog-code {
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-dialog {
  margin: 0 0 !important;
  display: flex;
  flex-direction: column;
  border-radius: 0.05rem;
}
.el-dialog-code .el-dialog__body {
  padding: 0 0;
}
.el-dialog__header {
  display: none;
}
.redbox{
/* 矩形 144 */
/* 矩形 144 */
margin-top:80px;
margin-left: 78px;
width: 394.75px;
height: 59px;
background: rgb(170, 32, 32);
border-radius:
10px;


}

.redbox1{
/* 矩形 144 */
/* 矩形 144 */
margin-top:40px;
margin-left: 78px;
width: 394.75px;
height: 59px;
background: rgb(170, 32, 32);
border-radius:
10px;


}
.pull {
  min-height: 20vh;
  overflow-x: hidden;
  text-align: center;
.pull-title {
    color: #000;
    font-weight: 500;
    font-size: 18px;
    text-align: center;
  }
  .pull-text {
    font-size: 14px;
    letter-spacing: 2px;
    padding: 20px;
    text-align: left;
  }
  .pull-sumbit {
/* rear_bg */
margin: auto;
text-align: center;
line-height: 40px;
margin-top: 50px;
color: #ffffff;
width: 95px;
height: 40px;
left: 0;
top: 0;
background: rgb(170, 32, 32);
  }
}
.yuyue{
position: absolute;
width: 552px;
height: 59px;
box-sizing: border-box;
background: rgb(246, 246, 246);
border: 1px solid rgb(162, 161, 161);
border-radius:
11px 11px 0px 0px;
}
.Btitle {
  color: #aa2020;
}
.Stitle {
  color: #0000006a;
  margin-bottom: 30px;
}

.login-form {
  border-radius: 6px;
  background: #ffffff;
  width: 400px;
  padding: 25px 25px 5px 25px;
  .el-input {
    height: 38px;
    input {
      height: 38px;
    }
  }
  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 2px;
  }
}
.PcStyle1 {
    font-size: 16px;
    height: calc(100% - 600px);
}
</style>